import { status } from "@otto-ec/global-resources/debug";

export class Logger {
    /*                          */

    static group(title) {
        if (status().enabled) {
            if (console.group) {
                console.group(title);
            }
        }
    }

    static groupEnd() {
        if (status().enabled) {
            if (console.groupEnd) {
                console.groupEnd();
            }
        }
    }

    static log(msg) {
        if (status().enabled) {
            console.log(msg);
        }
    }

    static warn(msg) {
        if (console.warn && status().enabled) {
            console.warn(msg);
        }
    }

    static table(table) {
        if (status().enabled) {
            if (console.table) console.table(table);
        }
    }

    static count(label) {
        if (status().enabled) {
            if (console.count) console.count(label);
        }
    }
}
